import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  const getName = (name: { en: string; pl: string; es: string; fr: string }) =>
    name[lang as 'en' | 'pl' | 'es' | 'fr'] || name.en;

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <p className="font-heading text-lg font-bold text-foreground-950">
              <span className="text-primary-600">USFans</span> Spreadsheet
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.col.explore')}</h4>
            <ul className="mt-3 flex flex-col gap-2">
              {categories.slice(0, 6).map((c) => (
                <li key={c.slug}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-foreground-950"
                  >
                    {getName(c.name)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.col.guides')}</h4>
            <ul className="mt-3 flex flex-col gap-2">
              <li>
                <Link to="/article/usfans-spreadsheet-guide" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('nav.guides')}
                </Link>
              </li>
              <li>
                <Link to="/topics/review" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('nav.review')}
                </Link>
              </li>
              <li>
                <Link to="/topics/shipping-cost" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('nav.shipping')}
                </Link>
              </li>
              <li>
                <Link to="/topics/safety" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('nav.safety')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t('footer.col.legal')}</h4>
            <ul className="mt-3 flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('footer.contact')}
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-foreground-950">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t('footer.disclaimer')}</p>
          <p className="mt-4 text-xs text-foreground-500">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}